import * as Slider from '@radix-ui/react-slider'

export type TRangeSliderProps = {
  max: number
  step?: number
  value: [number, number]
  onValueChange: (value: [number, number]) => void
  onValueCommit?: (value: [number, number]) => void
  className?: string
}

export const RangeSlider = ({
  max,
  step = 1,
  value,
  onValueChange,
  onValueCommit,
  className = ''
}: TRangeSliderProps) => {
  const handleValueChange = (newValue: number[]) => {
    onValueChange([0, newValue[1]])
  }

  const handleValueCommit = (newValue: number[]) => {
    if (onValueCommit) {
      onValueCommit([0, newValue[1]])
    }
  }

  return (
    <div className={`space-y-4 ${className}`}>
      <Slider.Root
        className="relative flex h-5 w-full touch-none select-none items-center"
        value={value}
        onValueChange={handleValueChange}
        onValueCommit={handleValueCommit}
        min={10}
        max={max}
        step={step}>
        <Slider.Track className="relative h-1 w-full grow rounded-full bg-gray-200">
          <Slider.Range className="absolute h-full rounded-full bg-primary-500" />
        </Slider.Track>

        <Slider.Thumb
          className="hidden h-5 w-5 cursor-not-allowed rounded-full border border-gray-300 bg-white"
          aria-label="Valor mínimo"
        />

        <Slider.Thumb
          className="block h-5 w-5 rounded-full border border-primary-500 bg-white shadow-lg transition-colors focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
          aria-label="Valor máximo"
        />
      </Slider.Root>
      <div className="flex items-center justify-between">
        <span className="text-sm text-gray-600">
          {Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(10)}
        </span>
        <span className="text-sm text-gray-600">
          {Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value[1])}
        </span>
      </div>
    </div>
  )
}
